module.exports = __webpack_public_path__ + "media/images/misora_hibari-d31140deb26bde233af481f1dc0bd4d7.png";